import React from "react";
import { AppContext } from "../../components/AppContext";
// resources
import logo from "../../img/logo.svg";
import "./Payments.scss";
import { withTranslation } from "react-i18next";
class EarlyAdopterPlanCanceled extends React.Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="section-login">
                <div className="section-login__logo">
                    <h1>
                        <img src={logo} alt="Optiwe logo" />
                        <span className="d-none">Optiwe</span>
                    </h1>
                    <p>{this.props.t("payments.paymentSystem")}</p>
                </div>
                <div className="section-login__form">
                    <p>{this.props.t("payments.canceled")}</p>
                </div>
            </div>
        );
    }
}
EarlyAdopterPlanCanceled.contextType = AppContext;
export default withTranslation()(EarlyAdopterPlanCanceled);
